import React, { Component, PropTypes } from 'react'

const STYLES = {
	padding: 1,
	borderBottomWidth: 1,
	borderBottomColor: 'grey',
	backgroundColor: '#e8eef1'
}

const OrderByBox = ({choices, handleOrderBy, sort}) => {

	let l = choices.map((el,idx)=>{
		let btnClass='btn btn-link';
		let sort_icon = ' ';
		if (el.field === sort.field){
			if (sort.dir === 'asc'){
					sort_icon = ' ↑'
			}
			if (sort.dir === 'desc'){
					sort_icon = ' ↓';
			}
		}
		//if (el.field === sort.field && el.dir === sort.dir){
		//	btnClass+=' disabled';
		//}
		return(
			<li key={idx} style={{paddingLeft: 1, paddingRight: 1, margin: 0, border:0}}>
				<button type="button" className={btnClass} onClick={handleOrderBy.bind(null,el.field)}>{el.label + sort_icon}</button>
			</li>
		);
	});

	return (
		<div>
			<ul className="list-inline" style={STYLES} >
			<span style={{paddingLeft: 3}}><strong>Trier par:</strong></span>
			{l}
			</ul>
		</div>
	)
}

OrderByBox.propTypes = {
	choices : PropTypes.arrayOf(
		PropTypes.shape(
			{field : PropTypes.string.isRequired, 
			 label: PropTypes.string
			})),
	handleOrderBy : PropTypes.func.isRequired,
	sort: PropTypes.shape({field: PropTypes.string, dir: PropTypes.string})
}

export default OrderByBox


// WEBPACK FOOTER //
// ./shared/orderbybox.js